exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea[data-v-07cd2ec6] {\n  resize: none;\n}\nthead.bg-light > tr > th[data-v-07cd2ec6] {\n  border-width: 1px;\n  border-top: none;\n}", ""]);

// exports
